import type { FC } from 'react';
import GlobalStylesUI, { GlobalStylesProps } from '@mui/material/GlobalStyles';

const globalStyle = {
  '*': {
    boxSizing: 'border-box',
    margin: 0,
    padding: 0,
  },
  html: {
    WebkitFontSmoothing: 'antialiased',
    MozOsxFontSmoothing: 'grayscale',
    height: '100%',
    width: '100%',
  },
  body: {
    height: '100%',
    width: '100%',
    '& .flash-animation': {
      animation: 'flash 2s linear infinite',
    },
    '@keyframes flash': {
      '50%': {
        filter: 'brightness(.8) saturate(1.1)',
      },
    },
  },
  '#root': {
    height: '100%',
    width: '100%',
  },
} as GlobalStylesProps['styles'];

const GlobalStyles: FC = () => (
  <GlobalStylesUI styles={globalStyle} />
);

export default GlobalStyles;
